const checkTrailerFsk = fsk => !(undefined === fsk || null === fsk || -1 === fsk || parseInt(fsk) > 15)

export default checkTrailerFsk
